// API
import apibridge from '../../apibridge';

// REDUX
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// TYPES
import { AccountUserUserDetails } from '../../api/models';

export interface UserType extends AccountUserUserDetails {
	forceUpdate?: boolean;
	loggedIn?: boolean;
	viewTrainingAsAdmin?: boolean;
	viewPoliciesAsAdmin?: boolean;
	viewChecklistAsAdmin?: boolean;
	viewFeedbackAsAdmin?: boolean;
	viewComplaintAsAdmin?: boolean;
	viewIncidentAsAdmin?: boolean;
}

const initialState: UserType = {
	forceUpdate: false,
	loggedIn: false,
	viewTrainingAsAdmin: true,
	viewPoliciesAsAdmin: true,
	viewChecklistAsAdmin: true,
	viewFeedbackAsAdmin: true,
	viewComplaintAsAdmin: true,
	viewIncidentAsAdmin: true,
	id: '',
	profileImage: '',
	childAwareId: undefined,
	email: '',
	firstName: '',
	lastName: '',
	activeProfileId: '',
	profiles: []
};

export const UserSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		logOut: (state) => {
			apibridge.doLogout();
			return { ...initialState };
		},
		update: (state, action: PayloadAction<UserType>) => {
			state = Object.assign(state, action.payload);
		},
		forceUpdate: (state, action: PayloadAction<{}>) => {
			state = Object.assign(state, {
				forceUpdate: true
			});
		}
	}
});

export default UserSlice;
